"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var idm_document_service_client_js_1 = require("@synisys/idm-document-service-client-js");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var core_1 = require("@angular/core");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var zip_1 = require("rxjs/observable/zip");
var of_1 = require("rxjs/observable/of");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var ExtractionService = /** @class */ (function () {
    function ExtractionService(kbService, deService, classifierService, documentService) {
        this.kbService = kbService;
        this.deService = deService;
        this.classifierService = classifierService;
        this.documentService = documentService;
        this.metaCategoryCache = new Map();
    }
    ExtractionService_1 = ExtractionService;
    ExtractionService.getStringFromField = function (entity, propertySystemName, currentLanguageId) {
        var result = entity.getProperty(propertySystemName).value;
        if (result instanceof idm_crosscutting_concepts_frontend_1.MultilingualString) {
            result = result.getValue(currentLanguageId);
        }
        return result;
    };
    ExtractionService.prototype.extractNameFromClassifierCached = function (classifier, compoundCategorySystemName, currentLanguageId) {
        var _this = this;
        if (classifier === null || classifier === undefined) {
            return of_1.of('');
        }
        return this.getMetaCategoryFromCache(compoundCategorySystemName).pipe(operators_1.map(function (metaCategory) {
            return _this.extractName(metaCategory, classifier, currentLanguageId);
        }));
    };
    ExtractionService.prototype.extractNameFromEntityCached = function (entity, compoundCategorySystemName, currentLanguageId) {
        return this.extractNameFromClassifier(entity, compoundCategorySystemName, currentLanguageId);
    };
    ExtractionService.prototype.extractNameFromClassifier = function (classifier, compoundCategorySystemName, currentLanguageId) {
        var _this = this;
        if (classifier === null || classifier === undefined) {
            return of_1.of('');
        }
        return this.kbService
            .getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(compoundCategorySystemName))
            .pipe(operators_1.map(function (metaCategory) {
            return _this.extractName(metaCategory, classifier, currentLanguageId);
        }));
    };
    ExtractionService.prototype.extractNameFromMultiSelect = function (classifiers, compoundCategorySystemName, currentLanguageId) {
        var _this = this;
        return zip_1.zip.apply(void 0, classifiers.map(function (classifier) {
            return _this.extractNameFromClassifier(classifier, compoundCategorySystemName, currentLanguageId);
        })).pipe(operators_1.map(function (classifiersNames) {
            return classifiersNames.join('; ');
        }));
    };
    ExtractionService.prototype.extractNameFromMultiSelectCached = function (classifiers, compoundCategorySystemName, currentLanguageId) {
        var _this = this;
        return zip_1.zip.apply(void 0, classifiers.map(function (classifier) {
            return _this.extractNameFromClassifierCached(classifier, compoundCategorySystemName, currentLanguageId);
        })).pipe(operators_1.map(function (classifiersNames) {
            return classifiersNames.join(', ');
        }));
    };
    ExtractionService.prototype.extractImageDocument = function (documentId, instanceId, categorySystemName, documentSystemName) {
        var _this = this;
        return this.kbService.getClassifierMetaCategories().pipe(operators_1.mergeMap(function (classifierMetaCategories) {
            for (var _i = 0, _a = Array.from(classifierMetaCategories); _i < _a.length; _i++) {
                var metaCategory = _a[_i];
                if (metaCategory.getSystemName() === categorySystemName) {
                    return _this.classifierService
                        .getDocumentAuthInfo(categorySystemName, instanceId, documentSystemName)
                        .pipe(operators_1.mergeMap(function (token) {
                        return _this.documentService.getDocumentUrl(documentId, token, idm_document_service_client_js_1.FileType.THUMBNAIL);
                    }));
                }
            }
            return _this.deService
                .getDocumentToken(categorySystemName, instanceId, documentSystemName)
                .pipe(operators_1.mergeMap(function (token) {
                return _this.documentService.getDocumentUrl(documentId, token, idm_document_service_client_js_1.FileType.THUMBNAIL);
            }));
        }));
    };
    ExtractionService.prototype.extractName = function (metaCategory, classifier, currentLanguageId) {
        if (metaCategory.getNameMetaFieldIds().length > 0) {
            return metaCategory
                .getNameMetaFieldIds()
                .map(function (metaFieldId) {
                return ExtractionService_1.getStringFromField(classifier, metaFieldId.getSystemName(), currentLanguageId);
            })
                .join(' ');
        }
        else {
            return (classifier &&
                ExtractionService_1.getStringFromField(classifier, 'name', currentLanguageId));
        }
    };
    ExtractionService.prototype.getMetaCategoryFromCache = function (compoundCategorySystemName) {
        if (this.metaCategoryCache.has(compoundCategorySystemName)) {
            return this.metaCategoryCache.get(compoundCategorySystemName);
        }
        else {
            var subject$_1 = new ReplaySubject_1.ReplaySubject(1);
            this.metaCategoryCache.set(compoundCategorySystemName, subject$_1);
            this.kbService
                .getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(compoundCategorySystemName))
                .subscribe(function (metaCategory) {
                subject$_1.next(metaCategory);
            }, function (err) { return console.error(err); });
            return subject$_1;
        }
    };
    ExtractionService = ExtractionService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_de_service_client_js_1.DeService,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_document_service_client_js_1.DocumentService])
    ], ExtractionService);
    return ExtractionService;
    var ExtractionService_1;
}());
exports.ExtractionService = ExtractionService;
//# sourceMappingURL=extraction.service.js.map